import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import {
	ApplicationConfig,
	ErrorHandler,
	importProvidersFrom,
	isDevMode,
	LOCALE_ID,
	provideZoneChangeDetection,
} from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, TitleStrategy, withInMemoryScrolling, withNavigationErrorHandler } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { devMockInterceptor } from '@core/dev/dev-mock.interceptor';
import { GoogleOAuthService } from '@core/services';
import { GlobalErrorHandler } from '@core/services/global-error-handler.service';
import { PageTitleStrategy } from '@core/services/page-title.strategy';
import { OAuthModule } from 'angular-oauth2-oidc';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { authInterceptor } from './core/requests/interceptors/auth.interceptor';
import { inflightInterceptor } from './core/requests/interceptors/inflight.interceptor';
import { loggingInterceptor } from './core/requests/interceptors/logging.interceptor';
import { offlineNavigationHandler } from './features/status/offline.component';
import { PrimeNgTheme } from './primeng.theme';

registerLocaleData(localePt, 'pt-BR');

export const appConfig: ApplicationConfig = {
	providers: [
		importProvidersFrom(OAuthModule.forRoot()),
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideHttpClient(
			withFetch(),
			withInterceptors([authInterceptor, inflightInterceptor, loggingInterceptor, devMockInterceptor])
		),
		provideAnimationsAsync(),
		provideRouter(
			routes,
			withInMemoryScrolling({
				anchorScrolling: 'enabled',
				scrollPositionRestoration: 'enabled',
			}),
			withNavigationErrorHandler(offlineNavigationHandler)
		),
		providePrimeNG({
			theme: {
				preset: PrimeNgTheme,
				options: {
					prefix: 'p',
					darkModeSelector: '.os-theme-dark',
					cssLayer: false,
				},
			},
			ripple: true,
		}),
		MessageService,
		GoogleOAuthService,
		{ provide: ErrorHandler, useClass: GlobalErrorHandler },
		{ provide: TitleStrategy, useClass: PageTitleStrategy },
		{ provide: LOCALE_ID, useValue: 'pt-BR' },
		/* O aplicativo instalável do canteiro. Só liga em produção: em
		   desenvolvimento, um service worker guardando arquivo velho confunde
		   mais do que ajuda. O manifesto é o que já existia em
		   assets/favicon/, com os ícones do ObraSync. */
		provideServiceWorker('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000',
		}),
		provideClientHydration(withEventReplay()),
	],
};
